// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TaobaoSvg from '@rsuite/icon-font/lib/platform/Taobao';
var Taobao = createSvgIcon({
  as: TaobaoSvg,
  ariaLabel: 'taobao',
  category: 'platform',
  displayName: 'Taobao'
});
export default Taobao;